import { useCallback } from 'react';
import { logEventString } from '@adv-frontend/yastore-modules/logger';
import { type ConstructorContent } from '#shared/api/schema';
import { constructorProductLoggingEvents } from '../lib/constructorProductLoggingEvents';
import {
    changeActiveVersion,
    changeConstructorGlobalSettings,
    changeConstructorPage,
    changePageSettings,
    resetConstructorAll,
    setConstructorFragments,
} from '../model/slices';
import { getConstructorPageOrder } from '../model/utils/getConstructorPageOrder';
import { useChangeConstructorRightBarSection } from './useChangeConstructorRightBarSection';

export const useApplyConstructorVersion = () => {
    const changeConstructorRightBarSection = useChangeConstructorRightBarSection();
    const apply = useCallback(
        (version: ConstructorContent) => {
            logEventString(constructorProductLoggingEvents.Version.Change, 'true', {
                versionId: String(version.version.id),
            });

            changeConstructorRightBarSection();

            const sortedPages = [...(version.pages || [])].sort(
                (a, b) => getConstructorPageOrder(a.alias) - getConstructorPageOrder(b.alias)
            );

            resetConstructorAll();
            sortedPages.forEach((page) => {
                changePageSettings({ pageId: page.id, pageSettings: page });
            });

            if (version.global_settings) {
                changeConstructorGlobalSettings(version.global_settings);
            }

            if (version.section_template_fragments) {
                setConstructorFragments(version.section_template_fragments);
            }

            changeConstructorPage(sortedPages[0]?.id);
            changeActiveVersion(version.version.id);
        },
        [changeConstructorRightBarSection]
    );

    return apply;
};
